import { Theme } from "@mui/material";

export const Variants = (theme: Theme) => {
    return {
      primary: {
        
      },
      secondary: {
        backgroundColor: theme.colors["neutral.950"],
        "&.MuiCheckbox-root:hover": {
          backgroundColor:`${theme.colors["neutral.950"]}`,
        },
      }
  }
}

export const SizeStyles = (theme: Theme) => {
    return {
        xs: {
            fontSize: theme.fontSizes.xs,
            padding: `${theme.space._100}`,
        },
        sm: {
            fontSize: theme.fontSizes.sm,
            padding: `${theme.space._100}`,
        },
        md: {
            fontSize: theme.fontSizes.sm,
            padding: `${theme.space._100}`,
        },
        lg: {
            fontSize: theme.fontSizes.md,
            padding: `${theme.space._150}`,
        }
    }
}

export const BackgroundColorStyles = (theme: Theme) => {
    return {
        checkedBackgroundColor: {
            backgroundColor: theme.colors["lime.500"]
        }
    }
}

export const CheckedStyles = (theme: Theme) => {
    
}